import A12Y_CONST from '../../common/a12yConst'
let initialState = {
    isLoggedIn: false,
    errMsg:'',
    code:'',
    isUpdated:false,
    isError:false,
    successMessage:'',
    isDataChanged:false,
    isSessionTimeout:false,
    isTrialReminder:false,
    IsWelcomePopUp:true,
    IsSurveyRolePopUp:false,
    IsSurvey_PopUp:false,
    isBillingScreen:false,
    isLogOutPopUP:false,
    userState : {
        access_token: null,
        refresh_token: null,
        isLoading: false,
        userInfo: {},
        error: null,
        isNotConfirmUser: null,
        id_token: null,
    },
    userSubscription:{},
    userSubscriptionAllDetails:{},
    firstTimeSubscription: null,
    loginAndSource:{},
    inviteCode:'',
    stripeConfig:{},
    paymentMethod:{},
    price_details:{},
    subscription:{},
    subscriptionProduct:[],
    userPlan:null,
    userRoleType:'',
    planName:'',
    signUpText:{
        title:'',
        description:'',
        otherDes:''
    },
    filterSelectedTypeList:[],
    filterSelectedTypeListIncome:[],
    filterData:{},
    proratedAmount: 0,
    nextBill: 0,
    prorationLoading: false,
    dependentEventLogs: [],
    subscriptionLoading: false,
    activationFee: null,
    excemptAllFee: false,
}

function userDetailReducer(state = initialState, action) {
    switch (action.type) {
        case A12Y_CONST.DISPATCH_ACTION.UNAUTHORIZED:
            return { ...state, isLoggedIn: false, isSessionTimeout:true }

        case A12Y_CONST.DISPATCH_ACTION.LOGIN_START:
            return { ...state, isLoggedIn: false, subscriptionLoading: true}

        case A12Y_CONST.DISPATCH_ACTION.LOGIN_SUCCESS:
            return { ...state, userState: action.userState , isLoggedIn : true}

        case A12Y_CONST.DISPATCH_ACTION.LOGIN_ERROR:
            return { ...state, isLoggedIn: false , errMsg:action.errMsg, code:action.code, subscriptionLoading: false}

        case A12Y_CONST.DISPATCH_ACTION.LOGOUT:
            return { ...state, userState: {
                    access_token: null,
                    refresh_token: null,
                    isLoading: false,
                    userInfo: {},
                    error: null,
                    isNotConfirmUser: null,
                    id_token: null,
                }, isLoggedIn: false,errMsg:'',
                code:'',
                isUpdated:false,
                isError:false,
                successMessage:'',
                isDataChanged:false,
                isSessionTimeout:false,
                isTrialReminder:false,
                IsWelcomePopUp:true,
                IsSurveyRolePopUp:false,
                IsSurvey_PopUp:false,
                isBillingScreen:false,
                isLogOutPopUP:false,
                userSubscription:{},
                userSubscriptionAllDetails:{},
                loginAndSource:{},
                inviteCode:'',
                stripeConfig:{},
                subscriptionProduct:[],
                paymentMethod:{},
                price_details:{},
                userPlan:null,
                userRoleType:'',
                planName:'',
                filterSelectedTypeList:[],
                filterSelectedTypeListIncome:[],
                filterData:{},
                signUpText:{
                    title:'',
                    description:'',
                    otherDes:''
                },
                subscriptionLoading: false
            }

        case A12Y_CONST.DISPATCH_ACTION.NOT_CONFIRM_USER:
            return { ...state, CustomerInformation: action.payload, isNotConfirmUser: true }

        case A12Y_CONST.DISPATCH_ACTION.SIGNUP_START:
             return { ...state, isLoggedIn: false, isError:false, errMsg:'', successMessage:''}

        case A12Y_CONST.DISPATCH_ACTION.SIGNUP_SUCCESS:
            return { ...state, userState: action.userState , isLoggedIn : false, isError:false, errMsg:'', successMessage:''}

        case A12Y_CONST.DISPATCH_ACTION.SIGNUP_ERROR:
            return { ...state, isLoggedIn: false , errMsg:action.errMsg, code:action.code, isError:true}

        case A12Y_CONST.DISPATCH_ACTION.UPDATE_USER_PROFILE_START:
            return { ...state, isUpdated:false , isError:false}

        case A12Y_CONST.DISPATCH_ACTION.UPDATE_USER_PROFILE_SUCCESS:
            return { ...state, userState: {...state.userState , ...state.userState.userInfo = action.userInfo} , isUpdated:true ,isError:false, successMessage:action.message }

        case A12Y_CONST.DISPATCH_ACTION.UPDATE_USER_PROFILE_ERROR:
            return { ...state, errMsg:action.errMsg, code:action.code , isUpdated:false , isError:true}


        case A12Y_CONST.DISPATCH_ACTION.UPDATE_USER_PASSWORD_START:
            return { ...state, isUpdated:false , isError:false}

        case A12Y_CONST.DISPATCH_ACTION.UPDATE_USER_PASSWORD_SUCCESS:
            return { ...state, isUpdated:true ,isError:false, successMessage:action.message }

        case A12Y_CONST.DISPATCH_ACTION.UPDATE_USER_PASSWORD_ERROR:
            return { ...state, errMsg:action.errMsg, code:action.code , isUpdated:false , isError:true}

        case A12Y_CONST.DISPATCH_ACTION.IS_FIELD_UPDATED:
            return { ...state, isDataChanged: action.payload.status}

        case A12Y_CONST.DISPATCH_ACTION.UPDATE_SESSION_TIMEOUT:
            return { ...state, isSessionTimeout: action.payload.isSessionTimeout}

        case A12Y_CONST.DISPATCH_ACTION.TOKEN_REFRESHED:
            let temp  = state.userState
            temp.access_token = action.refreshedToken.accessToken;
            temp.refresh_token = action.refreshedToken.refreshToken;
            temp.id_token = action.refreshedToken.idToken;
            return { ...state, userState: temp }

        case A12Y_CONST.DISPATCH_ACTION.CREATE_USER_SUBSCRIPTION_START:
            return { ...state, userSubscription: {}}

        case A12Y_CONST.DISPATCH_ACTION.CREATE_USER_SUBSCRIPTION_SUCCESS:
            let createdAllDetails = state.userSubscriptionAllDetails || {};
            if (action.userSubscription) {
                createdAllDetails = {
                    ...createdAllDetails,
                    subscription_details: action.userSubscription.subscription_details || action.userSubscription,
                    trial_period: action.userSubscription?.trial_period || action.userSubscription?.details?.trial_period || createdAllDetails.trial_period,
                    is_trial_expired: action.userSubscription?.is_trial_expired || action.userSubscription?.details?.is_trial_expired || createdAllDetails.is_trial_expired,
                    remaining_days: action.userSubscription?.remaining_days || action.userSubscription?.details?.remaining_days || createdAllDetails.remaining_days,
                    cancel_at_period_end: action.userSubscription?.cancel_at_period_end || action.userSubscription?.details?.cancel_at_period_end || createdAllDetails.cancel_at_period_end,
                    price_details: {
                        ...(createdAllDetails.price_details || {}),
                        ...(action.userSubscription.price_details || {}),
                        quantity: action.userSubscription.price_details?.quantity || action.userSubscription.quantity || createdAllDetails.price_details?.quantity
                    },
                    plan_name: action.userPlan?.plan_name || createdAllDetails.plan_name,
                    payment_method: action.paymentMethod ? {
                        card_last4: action.paymentMethod.card_last4,
                        card_type: action.paymentMethod.card_type,
                        card_expiration_month: action.paymentMethod.card_expiration_month,
                        card_expiration_year: action.paymentMethod.card_expiration_year,
                        is_valid: action.paymentMethod.is_valid,
                    } : createdAllDetails.payment_method,
                    paymentMethod: action.paymentMethod ? {
                        card_last4: action.paymentMethod.card_last4,
                        card_type: action.paymentMethod.card_type,
                        card_expiration_month: action.paymentMethod.card_expiration_month,
                        card_expiration_year: action.paymentMethod.card_expiration_year,
                        is_valid: action.paymentMethod.is_valid,
                    } : createdAllDetails.paymentMethod,
                };
            }
            return { ...state, userSubscription: action.userSubscription, paymentMethod:action.paymentMethod, isError: false, successMessage:action.message, userPlan:action.userPlan, userSubscriptionAllDetails: createdAllDetails}

        case A12Y_CONST.DISPATCH_ACTION.CREATE_USER_SUBSCRIPTION_ERROR:
            return { ...state, userSubscription: {}, paymentMethod: {}, errMsg:action.errMsg, code:action.code, isError: true}

        case A12Y_CONST.DISPATCH_ACTION.UPDATE_PAYMENT_METHOD_START:
            return { ...state, firstTimeSubscription: null }

        case A12Y_CONST.DISPATCH_ACTION.UPDATE_PAYMENT_METHOD_SUCCESS:
            let updatedAllDetails = state.userSubscriptionAllDetails || {};
            updatedAllDetails = {
                ...updatedAllDetails,
                    subscription_details: {
                    ...(updatedAllDetails.subscription_details || {}),
                    ...(action.userSubscription || {}),
                    subscription_status: action.userSubscription?.subscription_status?.toUpperCase() || updatedAllDetails.subscription_details?.subscription_status,
                },
                trial_period: action.userSubscription?.trial_period || action.userSubscription?.details?.trial_period || updatedAllDetails.trial_period,
                is_trial_expired: action.userSubscription?.is_trial_expired || action.userSubscription?.details?.is_trial_expired || updatedAllDetails.is_trial_expired,
                remaining_days: action.userSubscription?.remaining_days || action.userSubscription?.details?.remaining_days || updatedAllDetails.remaining_days,
                cancel_at_period_end: action.userSubscription?.cancel_at_period_end || action.userSubscription?.details?.cancel_at_period_end || updatedAllDetails.cancel_at_period_end,
                price_details: {
                    ...(updatedAllDetails.price_details || {}),
                    ...(action.price_details || {}),
                    quantity: action.subscription?.quantity || action.price_details?.quantity || updatedAllDetails.price_details?.quantity,
                },
                plan_name: action.planName || updatedAllDetails.plan_name,
                payment_method: action.paymentMethod ? {
                    card_last4: action.paymentMethod.card_last4,
                    card_type: action.paymentMethod.card_type,
                    card_expiration_month: action.paymentMethod.card_expiration_month,
                    card_expiration_year: action.paymentMethod.card_expiration_year,
                    is_valid: action.paymentMethod.is_valid,
                } : updatedAllDetails.payment_method,
                paymentMethod: action.paymentMethod ? {
                    card_last4: action.paymentMethod.card_last4,
                    card_type: action.paymentMethod.card_type,
                    card_expiration_month: action.paymentMethod.card_expiration_month,
                    card_expiration_year: action.paymentMethod.card_expiration_year,
                    is_valid: action.paymentMethod.is_valid,
                } : updatedAllDetails.paymentMethod,
            };
            return { 
                ...state, 
                price_details : action.price_details,
                userSubscription: action.userSubscription, 
                subscription: action.subscription,  
                paymentMethod: action.paymentMethod, 
                isError: false, 
                successMessage: action.message, 
                planName: action.planName,
                firstTimeSubscription: action.firstTimeSubscription || null,
                userSubscriptionAllDetails: updatedAllDetails
            }

        case A12Y_CONST.DISPATCH_ACTION.UPDATE_PAYMENT_METHOD_ERROR:
            return { ...state, errMsg:action.errMsg, code:action.code, isError: true, firstTimeSubscription: null }

        case A12Y_CONST.DISPATCH_ACTION.CANCEL_SUBSCRIPTION_START:
            return { ...state}

        case A12Y_CONST.DISPATCH_ACTION.CANCEL_SUBSCRIPTION_SUCCESS:
            return { ...state, userSubscription: action.userSubscription, paymentMethod:action.paymentMethod, isError: false, successMessage:action.message}

        case A12Y_CONST.DISPATCH_ACTION.CANCEL_SUBSCRIPTION_ERROR:
            return { ...state, errMsg:action.errMsg, code:action.code, isError: true}

        case A12Y_CONST.DISPATCH_ACTION.USER_SUBSCRIPTION_SUCCESS:
            return { ...state, userSubscriptionAllDetails: action.userSubscriptionAllDetails, userSubscription: action.userSubscription, stripeConfig: action.stripeConfig || state.stripeConfig || {}, subscriptionProduct:action.subscriptionProduct, paymentMethod:action.paymentMethod, userPlan:action.userPlan}

        case A12Y_CONST.DISPATCH_ACTION.USER_ROLE_TYPE:
            return { ...state, userRoleType:action.payload.type}

        case A12Y_CONST.DISPATCH_ACTION.SIGNUP_TEXT:
            return { ...state, signUpText:action.payload.type}

        case A12Y_CONST.DISPATCH_ACTION.IS_TRIAL_REMINDER:
            return { ...state, isTrialReminder: action.payload.status}

        case A12Y_CONST.DISPATCH_ACTION.IS_WELCOME_POPUP:
            return { ...state, IsWelcomePopUp: action.payload.status}

        case A12Y_CONST.DISPATCH_ACTION.IS_SURVEY_ROLE_POPUP:
            return { ...state, IsSurveyRolePopUp: action.payload.status}

        case A12Y_CONST.DISPATCH_ACTION.IS_SURVEY_POPUP:
            return { ...state, IsSurvey_PopUp: action.payload.status}

        case A12Y_CONST.DISPATCH_ACTION.BILLING_SCREEN:
            return { ...state, isBillingScreen: action.payload.status}

        case A12Y_CONST.DISPATCH_ACTION.INVITE_CODE:
            return { ...state, inviteCode:action.payload.type}

        case A12Y_CONST.DISPATCH_ACTION.USER_SOURCE_LOGIN:
            return { ...state, loginAndSource:action.payload.type}

        case A12Y_CONST.DISPATCH_ACTION.SET_LOGOUT_POPUP_STATUS:
            return { ...state, isLogOutPopUP: action.payload.status}

        case A12Y_CONST.DISPATCH_ACTION.SELECTED_FILLTER_TYPE_LIST:
            return { ...state, filterSelectedTypeList: action.payload.type}

        case A12Y_CONST.DISPATCH_ACTION.SELECTED_FILLTER_TYPE_LIST_INCOME:
            return { ...state, filterSelectedTypeListIncome: action.payload.type}

        case A12Y_CONST.DISPATCH_ACTION.SELECTED_FILTERED:
            const { dependentId, data, dataMap } = action.payload;
            if (dataMap) {
                const cleanDataMap = {};
                Object.keys(dataMap).forEach(depId => {
                    const cleanData = { ...dataMap[depId] };
                    if (cleanData.activity) {
                        cleanData.activity = { ...cleanData.activity };
                        if ('tag' in cleanData.activity) {
                            cleanData.activity.category_ids = cleanData.activity.tag;
                            delete cleanData.activity.tag;
                        }
                    }
                    cleanDataMap[depId] = cleanData;
                });
                return {
                    ...state,
                    filterData: {
                        ...state.filterData,
                        ...cleanDataMap
                    }
                };
            }
            if (!dependentId) {
                return state;
            }
            const cleanData = { ...data };
            if (cleanData.activity) {
                cleanData.activity = { ...cleanData.activity };
                if ('tag' in cleanData.activity) {
                    cleanData.activity.category_ids = cleanData.activity.tag;
                    delete cleanData.activity.tag;
                }
            }
            let currentFilterData = { ...state.filterData };
            if (currentFilterData.activity || currentFilterData.expense || currentFilterData.income) {
                currentFilterData = {};
            }
            return {
                ...state,
                filterData: {
                    ...currentFilterData,
                    [dependentId]: cleanData
                }
            }

        case A12Y_CONST.DISPATCH_ACTION.USER_SUBSCRIPTION_DETAIL_UPDATE:
            return { ...state, userSubscriptionAllDetails: action.payload.data}

        case A12Y_CONST.DISPATCH_ACTION.GET_SUBSCRIPTION_START:
            return { ...state, subscriptionLoading: true}

        case A12Y_CONST.DISPATCH_ACTION.GET_SUBSCRIPTION_SUCCESS:
            let detailUpdate = state.userSubscriptionAllDetails || {};
            let userPlan = state.userPlan;
            
            if (action.subscription && action.subscription.length > 0) {
                const activeSubscription = action.subscription.find(s => s.status === 'active' || s.status === 'trialing') || action.subscription[0];
                const activeItem = activeSubscription.items?.[0] || {};
                detailUpdate = {
                    ...detailUpdate,
                    subscription_details: {
                        ...(detailUpdate.subscription_details || {}),
                        subscription_status: activeSubscription.status ? activeSubscription.status.toUpperCase() : detailUpdate.subscription_details?.subscription_status,
                        stripe_customer_id: activeSubscription.stripe_customer_id || detailUpdate.subscription_details?.stripe_customer_id,
                        external_system_customer_id: activeSubscription.stripe_customer_id || detailUpdate.subscription_details?.external_system_customer_id,
                        renewal_date: activeSubscription.renewal_date || activeSubscription.current_period_end ? (typeof (activeSubscription.renewal_date || activeSubscription.current_period_end) === 'number' ? (activeSubscription.renewal_date || activeSubscription.current_period_end) * 1000 : new Date(activeSubscription.renewal_date || activeSubscription.current_period_end).getTime()) : (activeSubscription.trial_end ? activeSubscription.trial_end * 1000 : (activeSubscription.details?.renewal_date ? activeSubscription.details.renewal_date * 1000 : detailUpdate.subscription_details?.renewal_date)),
                        start_date: activeSubscription.start_date || activeSubscription.current_period_start ? (typeof (activeSubscription.start_date || activeSubscription.current_period_start) === 'number' ? (activeSubscription.start_date || activeSubscription.current_period_start) * 1000 : new Date(activeSubscription.start_date || activeSubscription.current_period_start).getTime()) : (activeSubscription.trial_start ? activeSubscription.trial_start * 1000 : (activeSubscription.details?.start_date ? activeSubscription.details.start_date * 1000 : detailUpdate.subscription_details?.start_date)),
                        end_date: activeSubscription.end_date || activeSubscription.current_period_end ? (typeof (activeSubscription.end_date || activeSubscription.current_period_end) === 'number' ? (activeSubscription.end_date || activeSubscription.current_period_end) * 1000 : new Date(activeSubscription.end_date || activeSubscription.current_period_end).getTime()) : (activeSubscription.trial_end ? activeSubscription.trial_end * 1000 : (activeSubscription.details?.end_date ? activeSubscription.details.end_date * 1000 : detailUpdate.subscription_details?.end_date)),
                        remaining_days: activeSubscription?.remaining_days !== undefined ? activeSubscription.remaining_days : (activeSubscription.details?.remaining_days !== undefined ? activeSubscription.details.remaining_days : detailUpdate.remaining_days),
                    },
                    trial_period: activeSubscription.trial_period !== undefined ? activeSubscription.trial_period : (activeSubscription.details?.trial_period !== undefined ? activeSubscription.details.trial_period : (activeSubscription.status === 'trialing' ? true : detailUpdate.trial_period)),
                    is_trial_expired: activeSubscription.is_trial_expired !== undefined ? activeSubscription.is_trial_expired : (activeSubscription.details?.is_trial_expired !== undefined ? activeSubscription.details.is_trial_expired : (activeSubscription.status === 'trialing' ? false : detailUpdate.is_trial_expired)),
                    remaining_days: activeSubscription?.remaining_days !== undefined ? activeSubscription.remaining_days : (activeSubscription.details?.remaining_days !== undefined ? activeSubscription.details.remaining_days : detailUpdate.remaining_days),
                    cancel_at_period_end: activeSubscription.cancel_at_period_end !== undefined ? activeSubscription.cancel_at_period_end : (activeSubscription.details?.cancel_at_period_end !== undefined ? activeSubscription.details.cancel_at_period_end : detailUpdate.cancel_at_period_end),
                    price_details: {
                        ...(detailUpdate.price_details || {}),
                        ...(activeSubscription.price_details || {}),
                        plan_amount: activeSubscription.price_details?.plan_amount ?? activeItem.plan_price ?? detailUpdate.price_details?.plan_amount,
                        plan_interval_display: activeSubscription.price_details?.plan_interval_display || activeItem.billing_period || detailUpdate.price_details?.plan_interval_display,
                        renewal_amount: activeSubscription.price_details?.renewal_amount ?? activeItem.plan_price ?? detailUpdate.price_details?.renewal_amount,
                        quantity: activeItem.quantity ?? detailUpdate.price_details?.quantity,
                    },
                    plan_name: activeItem.plan_name || detailUpdate.plan_name,
                    payment_method: activeSubscription.payment_method && Object.keys(activeSubscription.payment_method).length > 0 ? {
                        card_last4: activeSubscription.payment_method.last4,
                        card_type: activeSubscription.payment_method.brand,
                        card_expiration_month: activeSubscription.payment_method.exp_month,
                        card_expiration_year: activeSubscription.payment_method.exp_year,
                        is_valid: activeSubscription.payment_method.is_valid,
                    } : detailUpdate.payment_method,
                    paymentMethod: activeSubscription.payment_method && Object.keys(activeSubscription.payment_method).length > 0 ? {
                        card_last4: activeSubscription.payment_method.last4,
                        card_type: activeSubscription.payment_method.brand,
                        card_expiration_month: activeSubscription.payment_method.exp_month,
                        card_expiration_year: activeSubscription.payment_method.exp_year,
                        is_valid: activeSubscription.payment_method.is_valid,
                    } : detailUpdate.paymentMethod,
                };
                userPlan = {
                    ...(userPlan || {}),
                    plan_name: activeItem.plan_name || userPlan?.plan_name
                };
                
            }
            return { ...state, subscription: action.subscription, message: action.message, userSubscriptionAllDetails: detailUpdate, userPlan: userPlan, paymentMethod: detailUpdate.payment_method, subscriptionLoading: false}

        case A12Y_CONST.DISPATCH_ACTION.GET_SUBSCRIPTION_ERROR:
            return { ...state, errMsg:action.errMsg, code:action.code, isError: true, subscriptionLoading: false}

        case A12Y_CONST.DISPATCH_ACTION.GET_PRORATION_START:
            return { ...state, prorationLoading: true}

        case A12Y_CONST.DISPATCH_ACTION.GET_PRORATION_SUCCESS:
            return { ...state, proratedAmount: action.proratedAmount || 0, nextBill: action.nextBill || 0, activationFee: action.activationFee, excemptAllFee: action.excemptAllFee, prorationLoading: false}

        case A12Y_CONST.DISPATCH_ACTION.GET_PRORATION_ERROR:
            return { ...state, proratedAmount: 0, nextBill: 0, activationFee: null, excemptAllFee: false, prorationLoading: false}

        case A12Y_CONST.DISPATCH_ACTION.GET_DEPENDENT_EVENT_LOGS_START:
            return { ...state }

        case A12Y_CONST.DISPATCH_ACTION.GET_DEPENDENT_EVENT_LOGS_SUCCESS:
            return { ...state, dependentEventLogs: action.eventLogs || [] }

        case A12Y_CONST.DISPATCH_ACTION.GET_DEPENDENT_EVENT_LOGS_ERROR:
            return { ...state, dependentEventLogs: [] }

        default:
            return state
    }
}

const defaultFilters = {
    activity: { startDate: "", endDate: "", type: [], category_ids: [], isModify: false },
    expense: { startDate: "", endDate: "", type: [], reimbursable: null, isModify: false },
    income: { startDate: "", endDate: "", type: [], isModify: false },
};

export const getDependentFilters = (filterData, dependentId) => {
    if (!filterData) {
        return defaultFilters;
    }
    if (filterData.activity && ('tag' in filterData.activity || 'category_ids' in filterData.activity)) {
        const activity = { ...filterData.activity };
        if ('tag' in activity) {
            activity.category_ids = activity.tag;
            delete activity.tag;
        }
        return {
            activity,
            expense: filterData.expense || defaultFilters.expense,
            income: filterData.income || defaultFilters.income,
        };
    }
    if (dependentId && filterData[dependentId]) {
        const depFilters = filterData[dependentId];
        if (depFilters.activity && 'tag' in depFilters.activity) {
            const activity = { ...depFilters.activity };
            activity.category_ids = activity.tag;
            delete activity.tag;
            return {
                ...depFilters,
                activity
            };
        }
        return depFilters;
    }
    return defaultFilters;
};

export default userDetailReducer;